import React, { useEffect } from "react";
import { Typography, Upload, Button, Spin } from "antd";
import {
  InboxOutlined,
  PaperClipOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Dragger } = Upload;
const { Title } = Typography;

const Afip = ({ afips, isUploading, actions }) => {
  useEffect(() => {
    actions.getAfips();
  }, []);

  const uploadFile = (info) => {
    actions.afipUpload(info.file);
  };

  const handleRemove = (id) => {
    actions.afipDelete(id);
  };

  return (
    <div className="mt-24 mb-10 flex flex-col justify-center items-center">
      <Title className="text-dark-blue text-xl font-bold mb-6">AFIP FAJL</Title>
      <div className="w-[500px]">
        <Dragger
          iconRender={() => {
            return <PaperClipOutlined />;
          }}
          disabled={afips?.length >= 1 || isUploading}
          multiple={false}
          maxCount={1}
          accept=".json"
          customRequest={uploadFile}
          onRemove={handleRemove}
          showUploadList="false"
          className="h-40"
          name="json"
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Kliknite ovdje da bi dodali fajl</p>
          <p className="ant-upload-hint ">
            Podržava samo .json fajlove isporučene od strane AFIP-a
          </p>
        </Dragger>
      </div>

      {afips.length === 0 && isUploading && (
        <div className="mt-6 flex flex-col justify-center">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
          <Title className="text-light-blue-login text-sm font-bold mt-3">
            <>Ovo moze potrajati!</>
          </Title>
        </div>
      )}

      {afips?.length > 0 && (
        <div className="flex flex-col w-[500px]">
          <div className="mt-6">
            <div className="flex justify-between items-center">
              <div className="flex">
                <PaperClipOutlined />

                <a
                  className="text-light-blue-login ml-2"
                  href={afips[0]?.fileUrl}
                  target="_blank"
                >
                  {afips[0].fileName}
                </a>
              </div>
              <div>
                {isUploading && (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 20, marginRight: 16 }}
                        spin
                      />
                    }
                  />
                )}

                <Button
                  onClick={() => handleRemove(afips[0].id)}
                  type="dashed"
                  icon={<DeleteOutlined />}
                ></Button>
              </div>
            </div>
          </div>
          <div className="mt-6 flex">
            <Title className="text-dark-blue text-xl font-bold">
              DATUM ZADNJEG DODAVANJA:
            </Title>
            <Title className="text-light-blue-login text-xl font-bold ml-1 mt-0">
              <>{moment(afips[0]?.createdAt).format("DD.MM.YYYY")}</>
            </Title>
          </div>
        </div>
      )}
    </div>
  );
};

export default Afip;
